import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { setTheme, setFont } from "../redux/slices/uiPreferences";
import { ColourScheme, FontOptions } from "../types";

interface UseUIPreferencesReturn {
  theme: ColourScheme;
  font: FontOptions;
  updateTheme: (theme: ColourScheme) => void;
  updateFont: (font: FontOptions) => void;
}

export const useUIPreferences = (): UseUIPreferencesReturn => {
  const dispatch = useAppDispatch();
  const theme = useAppSelector((state) => state.uiPreferences.theme);
  const font = useAppSelector((state) => state.uiPreferences.font);

  const updateTheme = useCallback(
    (newTheme: ColourScheme) => {
      dispatch(setTheme(newTheme));
    },
    [dispatch]
  );

  const updateFont = useCallback(
    (newFont: FontOptions) => {
      dispatch(setFont(newFont));
    },
    [dispatch]
  );

  return {
    theme,
    font,
    updateTheme,
    updateFont,
  };
};
